(function () {
    'use strict';

    angular.module('ib-pmt-credit-card-tab-module', [
        'ib-pmt-required-fields-module',
        'ib-pmt-generic-credit-card-fields-module'
    ]);
})();